import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { SideNavigationInfo } from '@/constants/sideNavigation';
import SideMenuItem from './SideMenuItem';
import Naviagtion from '../navigation';

import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';

import defaultProfileIcon from '@/assets/sideBar/default_profile.png';
import {
  axiosRequestConfiguration,
  KIOSK_SERVER_TEST,
  SERVER_TEST,
} from '@/api/config';
import { validateReset } from '@/store/modules/validate';
import { reset } from '@/store/modules/refund';
import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { logOut } from '@/api/user';
import { loginUserState } from '@/store/modules/user';
import CashBillModal from './CashBillModal';
import useGetGlobalStatus from '@/hooks/useGetGlobalStatus';
import WarningIcon from '@/assets/common/error.png';
import PassportCheckModal from './PassportCheckModal';
import PaymentCancelModal from '../globalPayment/PaymentCancel.modal';

import useGlobalPaymentCRUD from '@/hooks/useGlobalPaymentCRUD';
import Cs from '@/components/sideNavigation/Cs';
import { PAYMENT_STATUS } from '@/constants/payment.const';
// import SettingMenu from '@/components/sideNavigation/SettingMenu';

function SideNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const name = localStorage.getItem('name');
  const profileImg = localStorage.getItem('profileImg');
  const [isTestServer, setIsTestServer] = useState(false);
  const [isOpenCashBillModal, setIsOpenCashBillModal] = useState(false);
  const { isKioskStore, adEnabled, hospitalId } = useAppSelector(
    (state) => state.user,
  );
  const { isPassportCheck, isPaymentReady } = useAppSelector(
    (state) => state.validate,
  );
  const accessToken = localStorage.getItem('loginToken');
  const kioskPermission = localStorage.getItem('kioskPermission');
  const isKioskSettingVisible = JSON.parse(
    localStorage.getItem('isKioskSettingVisible') || '{}',
  );
  const isGlobalPaymentUsable = JSON.parse(
    localStorage.getItem('isGlobalPaymentUsable') || 'false',
  );
  // 27:99999(전액결제테스트) 70:81818, 109:빈센트
  const isForeignCurrencyUsable =
    hospitalId === 70 || hospitalId === 109 || hospitalId === 27;
  //71:71717, 43:바로그의원
  const isDiscountUsable = hospitalId === 73 || hospitalId === 43;
  const { globalStatus } = useGetGlobalStatus(location.pathname);

  const [isPaymentCancelModalOn, setIsPaymentCancelModalOn] = useState(false);

  const { paymentInfo, updatePayment } = useGlobalPaymentCRUD();

  const [isPaymentCancelLoading, setIsPaymentCancelLoading] = useState(false);

  const isTestServerURL = (baseURL: string) => {
    return baseURL === SERVER_TEST || baseURL === KIOSK_SERVER_TEST;
  };

  useEffect(() => {
    const currentBaseURL: string = axiosRequestConfiguration.baseURL!;
    if (isTestServerURL(currentBaseURL)) {
      setIsTestServer(true);
    }
  }, []);

  useEffect(() => {
    dispatch(validateReset());
    dispatch(reset());
  }, [location]);

  const { refetch } = useQuery<null, AxiosError>('logOut', logOut, {
    enabled: false,
    retry: false,
    onSuccess: () => {
      localStorage.setItem('loginToken', '');
      dispatch(loginUserState(false));
      navigate('/');
    },
    onError: (error) => {
      console.log('에러', error);
    },
  });

  const [clickedLink, setClickedLink] = useState('');

  const onOpenPassportCheck = (event: React.MouseEvent, link: string) => {
    event.preventDefault();
    if (isPassportCheck) {
      setClickedLink(link);
    } else if (isPaymentReady) {
      setIsPaymentCancelModalOn(true);
    } else {
      window.location.href = link;
    }
  };

  const notKioskTabVisible = () => {
    // 있을 때
    if (isKioskStore) {
      if (isKioskSettingVisible.isKioskSettingVisible !== undefined) {
        return !isKioskSettingVisible.isKioskSettingVisible;
        // 없을 때
      } else {
        return kioskPermission === 'OWNER' ? false : true;
      }
    } else {
      return true;
    }
  };
  const handlePaymentCancel = async () => {
    try {
      await updatePayment({
        paymentId: paymentInfo?.id,
        newState: PAYMENT_STATUS.CANCELED,
        paymentAmount: 0,
      });
      setIsPaymentCancelModalOn(false);
    } catch (error) {
      console.error('결제 취소 중 오류 발생:', error);
    } finally {
      setIsPaymentCancelLoading(false);
    }
  };

  return (
    <>
      <Wrapper isTestServer={isTestServer}>
        <Container>
          <Naviagtion isTestServer={isTestServer} />
          <Profile>
            <ProfileImage
              src={profileImg ? profileImg : defaultProfileIcon}
              alt='프로필.'
              width='48px'
              height='48px'
            />
            <ProfileContent>
              안녕하세요.
              <br />
              <Bold>{name}</Bold> 님
            </ProfileContent>
          </Profile>
          <List>
            {SideNavigationInfo.map((item) => {
              if (!adEnabled && item.title === '배너 광고 설정') {
                return null;
              }
              if (!isGlobalPaymentUsable && item.title === '해외 간편 결제') {
                return null;
              }
              if (!isForeignCurrencyUsable && item.title === '현금 수납') {
                return null;
              }
              if (!isDiscountUsable && item.title === '할인 등록') {
                return null;
              }
              if (!isDiscountUsable && item.title === '할인 내역') {
                return null;
              }
              if (isDiscountUsable && item.title === '환급하기') {
                return null;
              }

              return (
                <LinkButton
                  key={item.id}
                  onClick={(e) => onOpenPassportCheck(e, item?.link[0])}
                >
                  {item.title === '키오스크 설정' && notKioskTabVisible() ? (
                    <></>
                  ) : (
                    <SideMenuItem menuItem={item} />
                  )}
                </LinkButton>
              );
            })}
            {/* TODO: 사이드메뉴 - 추후에 변경 */}
            {/* <SettingMenu /> */}
          </List>
        </Container>
        <BottomFixedButtons>
          <Cs />
          {accessToken &&
            !globalStatus?.isCashBillAgreed &&
            globalStatus?.paymentType === 'ORIGINAL' &&
            globalStatus?.isBeforeNovember && (
              <CashBillBtnWrapper>
                <WarnIcon src={WarningIcon} alt='' width={24} />
                <LinkBtn onClick={() => setIsOpenCashBillModal(true)}>
                  환급금 현금영수증 자동 발행
                </LinkBtn>
              </CashBillBtnWrapper>
            )}
        </BottomFixedButtons>
      </Wrapper>
      {isOpenCashBillModal && (
        <CashBillModal
          onClose={() => setIsOpenCashBillModal(false)}
          onCancel={() => setIsOpenCashBillModal(false)}
        />
      )}
      <PassportCheckModal
        isOpen={!!clickedLink}
        onClose={() => setClickedLink('')}
        link={clickedLink}
      />
      <PaymentCancelModal
        isOpen={isPaymentCancelModalOn}
        title='결제가 완료되지 않았습니다.'
        desc={
          '고객이 결제를 완료하지 않았거나 결제 중 페이지를 벗어나는 경우,\n현금 또는 카드로 반드시 결제를 완료해주세요.'
        }
        subBtnTitle='닫기'
        onClickSubBtn={() => {
          setIsPaymentCancelModalOn(false);
        }}
        btnTitle='현금/카드로 결제 진행'
        isBtnLoading={isPaymentCancelLoading}
        onClickBtn={handlePaymentCancel}
      />
    </>
  );
}

const Wrapper = styled.div<{ isTestServer: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 40px;
  position: relative;
  top: 0px;
  width: 200px;
  min-height: 100vh;
  background-color: ${(props) =>
    props.isTestServer ? 'green' : props.theme.blue[150]};

  z-index: 10;
  @media ${(props) => props.theme.largeView} {
    width: 280px;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const List = styled.ul`
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
`;

const Profile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 28px 32px;
`;

const ProfileImage = styled.img`
  object-fit: cover;
  border-radius: 100px;
`;

const ProfileContent = styled.span`
  font-size: ${(props) => props.theme.fontSize.small};
  line-height: ${(props) => props.theme.lineHeight.small};
  color: ${(props) => props.theme.blue[20]};
  font-weight: 400;
`;

const Bold = styled.span`
  font-size: ${(props) => props.theme.fontSize.medium};
  line-height: ${(props) => props.theme.lineHeight.medium};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  color: ${(props) => props.theme.pointColors.white};
  @media ${(props) => props.theme.laptop} {
    font-size: ${(props) => props.theme.fontSize.small};
    line-height: ${(props) => props.theme.lineHeight.small};
  }
`;
const CashBillBtnWrapper = styled.div`
  width: 100%;
  position: relative;
`;
const LinkBtn = styled.button`
  display: block;
  width: 100%;
  color: #a7c4fb;
  border: 1px solid #a7c4fb;
  padding: 12px;
  margin-top: 16px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
  @media ${(props) => props.theme.largeView} {
    padding: 14px;
  }
`;

const WarnIcon = styled.img`
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
`;

const LinkButton = styled.button`
  padding: 0;
`;

const BottomFixedButtons = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: auto;
  padding: 24px 16px;
`;

export default SideNavigation;
